import script from "./OpenTasksIndicator.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenTasksIndicator.vue?vue&type=script&lang=ts&setup=true"

import "./OpenTasksIndicator.vue?vue&type=style&index=0&id=6275e7f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6275e7f6"]])

export default __exports__